export const CREATE_CHANNEL_REQUEST = "channel/CREATE_CHANNEL_REQUEST";
export const CREATE_CHANNEL_SUCCESS = "channel/CREATE_CHANNEL_SUCCESS";
export const CREATE_CHANNEL_FAILURE = "channel/CREATE_CHANNEL_FAILURE";

export const READ_CHANNEL_REQUEST = "channel/READ_CHANNEL_REQUEST";
export const READ_CHANNEL_SUCCESS = "channel/READ_CHANNEL_SUCCESS";
export const READ_CHANNEL_FAILURE = "channel/READ_CHANNEL_FAILURE";

export const UPDATE_CHANNEL_REQUEST = "channel/UPDATE_CHANNEL_REQUEST";
export const UPDATE_CHANNEL_SUCCESS = "channel/UPDATE_CHANNEL_SUCCESS";
export const UPDATE_CHANNEL_FAILURE = "channel/UPDATE_CHANNEL_FAILURE";

export const DELETE_CHANNEL_REQUEST = "channel/DELETE_CHANNEL_REQUEST";
export const DELETE_CHANNEL_SUCCESS = "channel/DELETE_CHANNEL_SUCCESS";
export const DELETE_CHANNEL_FAILURE = "channel/DELETE_CHANNEL_FAILURE";

export const READ_CHANNELS_REQUEST = "channel/READ_CHANNELS_REQUEST";
export const READ_CHANNELS_SUCCESS = "channel/READ_CHANNELS_SUCCESS";
export const READ_CHANNELS_FAILURE = "channel/READ_CHANNELS_FAILURE";

export const TOP_SELLERS_REQUEST = "channel/TOP_SELLERS_REQUEST";
export const TOP_SELLERS_SUCCESS = "channel/TOP_SELLERS_SUCCESS";
export const TOP_SELLERS_FAILURE = "channel/TOP_SELLERS_FAILURE";



// WEBPACK FOOTER //
// ./src/modules/channel/channel.actionTypes.js